import React from 'react';
import { Link } from 'react-router-dom';

const SEVEN_DAYS_MS = 7 * 24 * 60 * 60 * 1000;

function badge(card) {
  if (String(card.status).toLowerCase().includes('pause')) {
    return { label: 'Paused', cls: 'bg-yellow-100 text-yellow-800' };
  }
  if (Date.now() - new Date(card.opened_date).getTime() > SEVEN_DAYS_MS) {
    return { label: 'Overdue', cls: 'bg-red-100 text-red-700' };
  }
  return { label: 'Open', cls: 'bg-orange-50 text-brand-primary' };
}

export default function PendingJobCards({ items = [], loading }) {
  return (
    <div className="bg-white border border-gray-100 rounded-2xl shadow-sm">
      <div className="flex justify-between items-center px-5 pt-4 pb-2 border-b-2 border-brand-primary">
        <h3 className="text-xs font-extrabold uppercase tracking-wider text-brand-secondary">
          Pending Job Cards
        </h3>
        <Link to="/job-cards/list" className="text-xs font-semibold text-brand-primary">
          View all →
        </Link>
      </div>
      <div className="px-5 py-3 space-y-2">
        {loading ? (
          <p className="text-xs text-gray-400 py-2">Loading...</p>
        ) : items.length === 0 ? (
          <p className="text-xs text-gray-400 py-2">No pending job cards.</p>
        ) : (
          items.map((card) => {
            const { label, cls } = badge(card);
            return (
              <div key={card.id} className="flex items-center justify-between py-1 border-b border-gray-50 last:border-b-0">
                <div className="min-w-0">
                  <span className="text-xs font-bold text-brand-secondary uppercase tracking-wide">
                    {card.plate_no}
                  </span>
                  {card.diagnosis && (
                    <span className="text-xs text-gray-500 ml-2 truncate">{card.diagnosis}</span>
                  )}
                </div>
                <span className={`text-[10px] font-bold px-2 py-0.5 rounded-full ml-2 shrink-0 ${cls}`}>
                  {label}
                </span>
              </div>
            );
          })
        )}
      </div>
    </div>
  );
}
